import { View } from "@react-pdf/renderer";
import {

  ResumePDFText,
  ProjectPDFLink,

} from "components/Resume/ResumePDF/common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeCertificate } from "lib/redux/types";
import { ResumePDFDescription, TemplateThirteenRightColumnSectionWithSubsections } from "./common";

export const Certificate = ({
  heading,
  certifications,
  themeColor,
  isPDF,
}: {
  heading: string;
  certifications: ResumeCertificate[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateThirteenRightColumnSectionWithSubsections themeColor={themeColor} heading={heading}>
      {certifications.map(
        ({ certificate, certificateLink, descriptions }, idx) => (
          <View key={idx} wrap={false}>
            <View
              style={{
                ...styles.flexRowBetween,
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText themeColor="white" bold={true}>{certificate}</ResumePDFText>
                {certificateLink && (
                  <ProjectPDFLink src={certificateLink}>
                    <ResumePDFIcon
                      type="url"
                      isPDF={isPDF}
                      themeColor={themeColor}
                    />
                  </ProjectPDFLink>
                )}
              </View>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} themeColor="white" />
            </View>
          </View>
        )
      )}
    </TemplateThirteenRightColumnSectionWithSubsections>
  );
};
